import React from 'react';
import { StyledDiv, Wrapper } from './styles';
import { services } from '../../other-services-db';
import { Service } from '../service';

export const Carousel = () => (
	<Wrapper>
		<StyledDiv>
			{services.map(el => (
				<Service {...el} key={el.name} />
			))}
		</StyledDiv>
	</Wrapper>
);
